import React from 'react';
import { bindHandler } from '../../utils';
export default function StarRating(props) {
    const { rating, ratingDisplayString, reviewCount, variant, primaryLink, maxRating, showRatingsCount, } = props.data;
    const bindHandlerHelper = (fn) => bindHandler(props.handleSelected, null, fn);
    return (React.createElement("music-star-rating", { rating: rating, reviewCount: reviewCount, ratingDisplayString: ratingDisplayString, variant: variant, onmusicActivate: bindHandlerHelper(primaryLink === null || primaryLink === void 0 ? void 0 : primaryLink.onItemSelected), maxRating: maxRating, showRatingsCount: showRatingsCount }));
}
